
































import {
    defineComponent,
    reactive,
    toRefs,
    PropType,
    computed,
} from '@vue/composition-api';
import { VMenu } from 'vuetify/lib/components';
import CnTextField from '@/components/Cn-TextField.vue';
import CnDatePicker from '@/components/Cn-DatePicker.vue';
const widthTypes = ['default', 'small', 'large'];
export default defineComponent({
    name: 'CnDateField',
    components: {
        VMenu,
        CnTextField,
        CnDatePicker,
    },
    props: {
        value: {
            type: String,
            required: false,
        },
        width: {
            type: String,
            required: false,
            default: 'default',
            validator: (prop: string) => widthTypes.includes(prop),
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Array as PropType<Array<(value: string) => boolean | string>>,
            default: () => [],
        },
        placeholderText: {
            type: String,
            default: 'Placeholder text',
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        isDob: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input'],
    setup(props, context) {
        // #region hooks
        // #endregion

        // #region data
        const state = reactive({
            isOpen: false,
            defaultWidth: computed(() => props.width === 'default'),
            smallWidth: computed(() => props.width === 'small'),
            largeWidth: computed(() => props.width === 'large'),
        });
        const widths = computed(() => {
            return {
                // classes for when the text field is standard width
                'TextFieldWidth-default':
                    state.defaultWidth && !props.fullWidth,
                // classes for when the text field is a smaller width
                'TextFieldWidth-small': state.smallWidth && !props.fullWidth,
                // classes for when the text field is a larger width
                'TextFieldWidth-large': state.largeWidth && !props.fullWidth,
            };
        });
        // #endregion

        // #region methods
        const onItemSelected = (value: string) => {
            context.emit('input', value);
        };
        // #endregion

        // #region lifeCycle
        // #endregion

        return {
            ...toRefs(state),
            onItemSelected,
            widths,
        };
    },
});
